import { FC, SVGProps } from 'react';

const CustomFieldTextIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 16,
  ...props
}) => {
  return (
    <svg width={'10'} height={'10'} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.66629 0.480011V8.98856M2.8208 8.98856H6.59256"
        stroke={color}
        stroke-width="0.96"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.47998 1.97961V0.480011H8.93393V1.97961"
        stroke={color}
        stroke-width="0.96"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CustomFieldTextIcon;
